<template lang='pug'>
  v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon attach_file
            h4.title
              | {{ $t("webChannel.attachmentsSettings.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              //- .md-layout
              //-   .md-layout-item(style='margin: auto;')
              //-     |
              //-     | $t(
              //-     | "webChannel.attachmentsSettings.subitems.status"
              //-     | )
              //-     | }}
              //-   .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
              //-   'text-success': canalWebData.isAttachmentActive,\
              //-   'text-danger': !canalWebData.isAttachmentActive\
              //-   }")
              //-     |
              //-     | canalWebData.isAttachmentActive
              //-     | ? $t("commonWords.enabled")
              //-     | : $t("commonWords.disabled")
              //-     | }}
              //-   .md-layout-item.md-size-15
              //-     md-switch(v-model='canalWebData.isAttachmentActive')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.attachmentsSettings.subitems.saveOnCloud"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success': canalWebData.isStoredAttachments,\
                'text-danger': !canalWebData.isStoredAttachments\
                }")
                  | {{
                  | canalWebData.isStoredAttachments
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.isStoredAttachments')
              .md-layout
                .md-layout-item(id='attachment-autocomplete' style='margin: auto')
                  v-autocomplete(
                    v-model='supportedFileTypes'
                    :items='fileTypeItems'
                    hide-details
                    hide-selected
                    chips
                    menu-props="openOnClick"
                    small-chips
                    :label='$t("webChannel.attachmentsSettings.subitems.fileType")' :no-data-text='$t("webChannel.attachmentsSettings.subitems.nomMoreFileTypes")' multiple)
                    template(v-slot:selection='data')
                      v-hover(v-slot:default="{ hover }")
                        v-chip(v-bind='data.attrs' :input-value='data.selected' small @click='data.select')
                          | {{ data.item.value.title }}
                          v-icon(@click='remove(data.item)' style='margin-left: 4px;') mdi-close
              .md-layout
                .md-layout-item.md-size-50
                  md-field(style='margin-top: 30px')
                    label
                      | {{
                      | $t(
                      | "webChannel.attachmentsSettings.subitems.fileMaxLimit"
                      | )
                      | }} (MB - Megabytes)
                    md-input(v-model='canalWebData.attachmentMaxSizeMB' type='number' v-mask='sizeMask')
                .md-layout-item.md-size-50
                  md-field(style='margin-top: 30px')
                    label
                      | {{
                      | $t(
                      | "webChannel.attachmentsSettings.subitems.fileMinLimit"
                      | )
                      | }} (MB - Megabytes)
                    md-input(v-model='canalWebData.attachmentMinSizeMB' type='number' v-mask='sizeMask')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "webChannel.attachmentsSettings.subitems.sizeLimitMessage",
                      | { size: computedFileSize }
                      | )
                      | }}
                    md-input(v-model='canalWebData.attachmentSizeLimitMessage')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "webChannel.attachmentsSettings.subitems.fileNotSupportedMessage"
                      | )
                      | }}
                    md-input(v-model='canalWebData.attachmentNotSupportedMessage')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "webChannel.attachmentsSettings.subitems.successfulUploadMessage"
                      | )
                      | }}
                    md-input(v-model='canalWebData.attachmentSuccessMessage')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "webChannel.attachmentsSettings.subitems.attachmentWaitingMsg"
                      | )
                      | }}
                    md-input(v-model='canalWebData.attachmentAwaitMessage')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "webChannel.attachmentsSettings.subitems.loadingFileError"
                      | )
                      | }}
                    md-input(v-model='canalWebData.attachmentFailureMessage')
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
  directives: { mask },
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedFileSize () {
      return this.bytesToSize(this.canalWebData.attachmentMaxSizeMB)
    }
  },
  watch: {
    supportedFileTypes (nV) {
      let updatedAllowedArray = []
      nV.forEach(type => {
        updatedAllowedArray = [...updatedAllowedArray, ...type.type]
      })
      this.canalWebData.attachmentAllowedTypes = updatedAllowedArray
    }
  },
  data () {
    return {
      status: true, // Permitir Envio de Anexos
      supportedFileTypes: [
      ],
      fileMaxLimit: 5000000, // Tamanho máximo do arquivo
      fileMinLimit: 0, // Tamanho mínimo do arquivo
      sizeLimitMessage: this.$t('attachments.sorryTheFileExceedsThe5mbLimit'),
      fileNotSupportedMessage: this.$t('attachments.sorryTheFileFormatIsNotSupported'),
      successfulUploadMessage: this.$t('attachments.attachmentSentSuccessfully'),
      attachmentWaitingMsg: this.$t('attachments.pleaseWaitAMoment'),
      loadingFileError: '',
      // Mocado
      filePermission: 'private',

      // locais
      sizeMask: '#################################',
      fileTypeItems: [
        {
          text: 'PDF',
          value: {
            title: 'PDF',
            type: ['pdf']
          }
        },
        {
          text: '.xls, .xlsx',
          value: {
            title: '.xls, .xlsx',
            type: [
              'xls',
              'xlsx',
              'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ]
          }
        },
        {
          text: 'doc, docx',
          value: {
            title: 'doc, docx',
            type: [
              'doc',
              'docx',
              'vnd.openxmlformats-officedocument.wordprocessingml.document'
            ]
          }
        },
        {
          text: 'plain',
          value: {
            title: 'plain',
            type: ['plain']
          }
        },
        {
          text: this.$t('commonWords.audio') + ' (mp3)',
          value: {
            title: this.$t('commonWords.audio') + ' (mp3)',
            type: ['mp3']
          }
        },
        {
          text: '.zip',
          value: {
            title: '.zip',
            type: ['zip', 'x-zip-compressed']
          }
        },
        {
          text: this.$t('commonWords.image'),
          value: {
            title: this.$t('commonWords.image'),
            type: ['jpeg', 'jpg', 'png', 'gif', 'svg']
          }
        }
      ]
    }
  },
  methods: {
    bytesToSize (bytes) {
      // var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      // if (bytes === 0) return '0 Byte'
      // var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      // if (i < 5) {
      //   return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
      // } else {
      //   return Math.round(bytes / Math.pow(1024, 4), 2) + ' TB'
      // }
      var sizes = ['MB', 'GB', 'TB']
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)))
      if (i < 3) {
        let num = bytes / Math.pow(1000, i)
        let numTrnc = Math.trunc(parseFloat(num) * 100) / 100
        let numStr = numTrnc.toString().replace('.', ',')
        return numStr + ' ' + sizes[i]
      } else {
        let num = bytes / Math.pow(1000, 2)
        let numTrnc = Math.trunc(parseFloat(num) * 100) / 100
        let numStr = numTrnc.toString().replace('.', ',')
        return numStr + ' TB'
      }
    },
    remove (item) {
      for (let i = 0; i < this.supportedFileTypes.length; i++) {
        if (item.text === this.supportedFileTypes[i].title) {
          this.supportedFileTypes.splice(i, 1)
        }
      }
    },
    convertIntoAutcompleteType (typeArray) {
      for (let index = 0; index < typeArray.length; index++) {
        for (let i = 0; i < this.fileTypeItems.length; i++) {
          if (typeArray[index] === this.fileTypeItems[i].value.type[0]) {
            this.supportedFileTypes.push(this.fileTypeItems[i].value)
            const valuesLength = this.fileTypeItems[i].value.type.length
            index += valuesLength - 1
            break
          }
        }
      }
    }
  },
  mounted () {
    this.convertIntoAutcompleteType(this.canalWebData.attachmentAllowedTypes)
  }
}
</script>

<style>
/* .v-input .v-label {
  line-height: 12px;
} */
/* .v-text-field .v-label {
  top: 0px !important;
  left: 0px !important;
} */
#attachment-autocomplete .v-icon.v-icon {
  font-size: 18px !important;
}
#attachment-autocomplete .theme--light.v-input, .theme--light.v-input textarea {
  color: #9c27b0 !important;
}
#attachment-autocomplete .v-chip.v-size--small {
  height: 20px !important;
}
#attachment-autocomplete .v-label {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #AAAAAA !important;
}
#attachment-autocomplete .theme--light.v-chip {
  background: #ff9800 !important;
}
</style>
